(function () {
  var cfgEl = document.getElementById('fs-config');
  if (!cfgEl) return;

  var CFG = {
    reveal: cfgEl.getAttribute('data-reveal'),
    first: cfgEl.getAttribute('data-first'),
    last: cfgEl.getAttribute('data-last'),
    open: cfgEl.getAttribute('data-open'),
    close: cfgEl.getAttribute('data-close'),
    label: cfgEl.getAttribute('data-label') || 'Ulje e çmendur',
    money: cfgEl.getAttribute('data-money') || 'Lek {n}'
  };

  function alNow() {
    try { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Tirane' })); }
    catch (e) { return new Date(); }
  }
  function mk(ds, ts) {
    var a = String(ds || '').split('-'), b = String(ts || '00:00').split(':');
    if (a.length < 3) return null;
    return new Date(+a[0], +a[1] - 1, +a[2], +b[0] || 0, +b[1] || 0, 0, 0);
  }
  function addDays(dt, n) { var x = new Date(dt.getTime()); x.setDate(x.getDate() + n); return x; }
  function dayStr(dt) {
    return dt.getFullYear() + '-' + ('0' + (dt.getMonth() + 1)).slice(-2) + '-' + ('0' + dt.getDate()).slice(-2);
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function lek(n) {
    var s = String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return CFG.money.replace('{n}', s);
  }

  var revealParts = String(CFG.reveal || '').trim().split(' ');
  var revealDT = mk(revealParts[0], revealParts[1] || '00:00');

  var forced = null;
  try {
    var q = new URLSearchParams(window.location.search).get('fs');
    if (q) forced = q;
  } catch (e) {}

  function resolve(now) {
    if (forced) {
      if (forced === 'live') return { state: 'live', start: new Date(now.getTime() - 99 * 60000), target: new Date(now.getTime() + 41 * 60000) };
      if (forced === 'urgent') return { state: 'live', start: new Date(now.getTime() - 173 * 60000), target: new Date(now.getTime() + 7 * 60000) };
      if (forced === 'closed') return { state: 'closed', target: new Date(now.getTime() + 20.5 * 3600000) };
      if (forced === 'ended') return { state: 'ended', target: null };
      if (forced === 'soon') return { state: 'soon', target: new Date(now.getTime() + 9.5 * 3600000) };
      return { state: 'teaser', target: new Date(now.getTime() + 7.25 * 3600000) };
    }
    var firstOpen = mk(CFG.first, CFG.open);
    var today = dayStr(now);
    if (revealDT && now < revealDT) return { state: 'soon', target: firstOpen };
    if (today < CFG.first) return { state: 'teaser', target: firstOpen };
    if (today > CFG.last) return { state: 'ended', target: null };
    var o = mk(today, CFG.open), c = mk(today, CFG.close);
    if (c <= o) c = addDays(c, 1);
    if (now < o) return { state: 'teaser', target: o };
    if (now < c) return { state: 'live', start: o, target: c };
    if (today < CFG.last) return { state: 'closed', target: addDays(o, 1) };
    return { state: 'ended', target: null };
  }

  var bar = document.getElementById('fs-bar');
  var el = {
    fill: document.getElementById('fs-bar-fill'),
    name: document.getElementById('fs-bar-name'),
    goal: document.getElementById('fs-bar-goal'),
    clock: document.getElementById('fs-bar-clock'),
    prog: document.getElementById('fs-bar-prog'),
    progFill: document.getElementById('fs-bar-progfill')
  };

  var cart = { total: 0, item: null, prag: 0 };
  var tagCache = {};
  var loading = false;

  function pragFromTags(tags) {
    if (!tags) return 0;
    for (var i = 0; i < tags.length; i++) {
      var t = String(tags[i]);
      if (t.indexOf('ulje-prag-') === 0) {
        var n = parseInt(t.replace('ulje-prag-', ''), 10);
        if (n > 0) return n;
      }
    }
    return 0;
  }

  function readCart() {
    if (loading || typeof window.fetch !== 'function') return;
    loading = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return null;
        cart.total = (c.total_price || 0) / 100;
        var items = c.items || [];
        var pending = [];
        for (var i = 0; i < items.length; i++) {
          var h = items[i].handle;
          if (h && tagCache[h] === undefined) pending.push(h);
        }
        if (!pending.length) return items;
        return Promise.all(pending.map(function (h) {
          return fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (p) { tagCache[h] = p ? pragFromTags(p.tags) : 0; })
            .catch(function () { tagCache[h] = 0; });
        })).then(function () { return items; });
      })
      .then(function (items) {
        cart.item = null;
        cart.prag = 0;
        if (items) {
          for (var i = 0; i < items.length; i++) {
            var p = tagCache[items[i].handle] || 0;
            if (p > cart.prag) { cart.prag = p; cart.item = items[i].product_title || items[i].title; }
          }
        }
        paintCart();
      })
      .catch(function () {})
      .then(function () { loading = false; }, function () { loading = false; });
  }

  function paintCart() {
    if (!bar) return;
    if (!cart.prag) {
      if (el.name) el.name.textContent = CFG.label;
      if (el.goal) el.goal.textContent = '';
      if (el.prog) el.prog.hidden = true;
      bar.classList.remove('is-ready');
      return;
    }
    var missing = cart.prag - cart.total;
    if (el.name) el.name.textContent = cart.item || CFG.label;
    if (el.prog) el.prog.hidden = false;
    var pct = cart.prag > 0 ? (cart.total / cart.prag) * 100 : 0;
    if (pct > 100) pct = 100;
    if (pct < 0) pct = 0;
    if (el.progFill) el.progFill.style.width = pct.toFixed(1) + '%';
    if (missing > 0) {
      bar.classList.remove('is-ready');
      if (el.goal) el.goal.textContent = 'Të mungojnë ' + lek(missing);
    } else {
      bar.classList.add('is-ready');
      if (el.goal) el.goal.textContent = 'Gati — mund të përfundosh porosinë';
    }
  }

  var lastState = '';
  function tick() {
    var now = alNow();
    var r = resolve(now);
    var de = document.documentElement;

    if (r.state !== lastState) {
      lastState = r.state;
      de.classList.remove('fs-state-soon', 'fs-state-teaser', 'fs-state-live', 'fs-state-closed', 'fs-state-ended');
      de.classList.add('fs-state-' + r.state);
      if (r.state === 'live') readCart();
    }

    var ms = 0;
    if (r.target) {
      ms = r.target - now;
      if (ms < 0) ms = 0;
    }

    if (r.state === 'live' && bar) {
      var s = Math.floor(ms / 1000);
      if (el.clock) el.clock.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60);
      if (el.fill && r.start) {
        var total = r.target - r.start;
        var left = total > 0 ? (ms / total) * 100 : 0;
        el.fill.style.width = Math.max(0, Math.min(100, left)).toFixed(2) + '%';
      }
      if (s <= 600) bar.classList.add('is-urgent'); else bar.classList.remove('is-urgent');
    }

    window.FSSTATE = { state: r.state, ms: ms, target: r.target, start: r.start || null };
    try { document.dispatchEvent(new CustomEvent('fs:tick', { detail: window.FSSTATE })); } catch (e) {}
  }

  tick();
  setInterval(tick, 1000);

  var cartTimer = null;
  function scheduleCart() {
    if (lastState !== 'live') return;
    clearTimeout(cartTimer);
    cartTimer = setTimeout(readCart, 700);
  }
  document.addEventListener('click', scheduleCart, true);
  document.addEventListener('submit', scheduleCart, true);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) scheduleCart(); });
  setInterval(function () { if (lastState === 'live') readCart(); }, 8000);
})();
